const Header =() => {
    return (
        <header>
        
       <div className="center"> <h1>To Do List</h1></div>
        
        </header>
    )
}

export default Header



